import { Navigate, Route, Routes } from "react-router";
import ScrollToTop from "./components/ScrollToTop";
import InitialPage from "./pages/Initial";
import CustomerPage from "./pages/Customer";
import CompletePage from "./pages/Complete";

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<InitialPage />} />
        <Route path="/customer" element={<CustomerPage />} />
        <Route path="/complete" element={<CompletePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
